import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

export default function Property({ thumbnail, name, location }) {
  return (
      <Card>
        <CardMedia
          component="img"
          alt="green iguana"
          height="200"
          image={thumbnail} 
          onError={(e) => { e.target.src = "../assets/app/digivalet_placeholder.png"; }}
          />
        <CardContent>
          <div style={{ textAlign: "center" }}>
            <Typography gutterBottom variant="" component="div" sx={{ fontSize: '120%', fontWeight: 'bold', display: 'inline-block', verticalAlign: 'middle' }}>
              {name}
            </Typography>
          </div>
          <Typography variant="body2" color="text.secondary">
            Location : {location}
          </Typography>
        </CardContent>
      </Card>
  );
}

Property.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
}